export const formInputGroups = {
    "Personal Details": {
        group1: {
            alternateContact: {
                type: "phone"
            },
            dob: {
                type: "date"
            },
        },
        group2: {
            currentResidential: {
                type: "textarea"
            },
            permanentResidential: {
                type: "textarea"
            },
            city: {
                type: "text"
            },
            pin: {
                type: "number"
            }
        },
        group3: {
            language: {
                type: "text"
            },
            motherTongue: {
                type: "text"
            },
            familyMembers: {
                type: "number"
            },
            dependentFamilyMembers: {
                type: "number"
            }
        },
        group5: {
            gender: {
                type: "radio"
            },
        },
    },
    "University Details": {
        group1: {
            universityRegistrationNumber: {
                type: "text"
            },
            universitySeatNumber: {
                type: "text"
            },
        },
    },
    "Educational Qualification": {
        group1: {
            highestQualification: {
                type: "text"
            },
            stream: {
                type: "text"
            },
            collegeName: {
                type: "text"
            },
            percentage: {
                type: "text"
            },
            yearOfPassing: {
                type: "year"
            },
            educationSpecialization: {
                type: "text"
            },
        },
        group2: {
            twelfthPercentage: {
                type: "text"
            },
            twelfthYearOfPassing: {
                type: "year"
            },
        },
        group3: {
            tenthPercentage: {
                type: "text"
            },
            tenthYearOfPassing: {
                type: "year"
            },
        }
    },
    "Job Details": {
        group1: {
            candidateType: {
                type: "radio"
            },
        },
        group2: {
            industry: {
                type: "single-select"
            },
            currentCompany: {
                type: "text"
            },
            workExperience: {
                type: "single-select"
            },
        },
        group3: {
            state: {
                type: "single-select"
            },
            currentLocation: {
                type: "text"
            },
            workedInBank: {
                type: "radio"
            },
            verticalType: {
                type: "radio"
            },
            yearsOfExp: {
                type: "number"
            },
            compensation: {
                type: "number"
            },
            company: {
                type: "text"
            },
            noticePeriod: {
                type: "number"
            },
        },
        group4: {
            locationPreference: {
                type: "multi-select"
            }
        },
        group5: {
            edpId: {
                type: "text",
                tooltipText: `Please mention your  issued Godrej Employee ID (see your employee badge). If you do not have a Godrej Employee ID, please mention as N/A`
            },
        },
        group6: {
            zoneName: {
                type: "single-select"
            },
            site: {
                type: "single-select"
            },
        },
        group7: {
            productWorked: {
                type: "single-select"
            },
            ticketSize: {
                type: "single-select"
            },
            avgIncentive: {
                type: "single-select"
            },
            sourceOfHiring: {
                type: "text"
            },
            referral: {
                type: "text"
            },
            branchDistance: {
                type: "text"
            },
        },
    },
    "Upload Resume": {
        group1: {
            resumeUpload: {
                type: "file"
            }
        }
    }
}

export const initialValues = {
    alternateContact: "",
    dob: "",
    currentResidential: "",
    permanentResidential: "",
    gender: "",
    highestQualification: "",
    stream: "",
    collegeName: "",
    percentage: "",
    yearOfPassing: "",
    twelfthPercentage: "",
    twelfthYearOfPassing: "",
    tenthPercentage: "",
    tenthYearOfPassing: "",
    resumeUpload: "",
    universitySeatNumber: "",
    universityRegistrationNumber: "",
    language: "",
    yearsOfExp: "",
    compensation: "",
    locationPreference: "",
    edpId: "",
    zoneName: "",
    site: "",
    city: "",
    pin: "",
    company: "",
    noticePeriod: "",
    verticalType: "",
    productWorked: "",
    ticketSize: "",
    avgIncentive: "",
    workedInBank: "",
    sourceOfHiring: "",
    referral: "",
    branchDistance: "",
    educationSpecialization: "",
    familyMembers: "",
    dependentFamilyMembers: "",
    motherTongue: "",
    candidateType: "",
    currentLocation: "",
    state: "",
    industry: "",
    currentCompany: "",
    workExperience: "",
}

export const acceptedFileTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]

const locationOptions = ["Mumbai", "Pune", "Chennai", "Bengaluru", "Hyderabad", "Coimbatore", "Kolkata"]

const zoneOptions = ["North", "South", "Mumbai/MMR", "West-East"]

const genderOptions = ["male", "female", "others", "dont_prefer"]

const verticalTypeOptions = ["secured", "unsecured"]

const productWorkedOptions = ["HL", "UBL", "LAP", "UCL", "PL", "SA.CA", "None"]

const ticketSizeOptions = ["Fresher", "50K and below", "50K - 2L", "2L - 5L", "5L - 10L", "10L and above"]

const incentiveOptions = ["Nil", "Less than 3k", "3k - 7k", "7k - 10k", "10k and above"]

const workedInBankOptions = ["yes", "no"]

const candidateTypeOptions = ["experienced", "fresher"]

const industryOptions = ["Banking", "NBFC", "Insurance", "Others"]

const workExperienceOptions = ["0-2 years", "2-5 years", "5-10 years", "10+ years"]

const stateOptions = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
]

export const experiencedOnlyInputs = ["industry", "currentCompany", "workExperience"]

export const dropdownInputOptions = {
    zoneName: zoneOptions,
    locationPreference: locationOptions,
    "North-site": [
        "ASHOK VIHAR",
        "FARIDABAD",
        "GODREJ AIR",
        "GODREJ ARIA/101",
        "GODREJ GOLF LINK",
        "GODREJ HABITAT",
        "GODREJ KURUKSHETRA",
        "GODREJ MERIDIEN",
        "GODREJ NATURE PLUS",
        "GODREJ NEST & NURTURE",
        "GODREJ PALM RETREAT",
        "GODREJ SECTOR 103",
        "GODREJ SECTOR 146",
        "GODREJ SECTOR 43 GGN",
        "GODREJ SECTOR 49",
        "GODREJ SECTOR 54",
        "GODREJ SECTOR 89",
        "GODREJ SOUTH ESTATE",
        "GODREJ SUMMIT",
        "GODREJ TDI",
        "GODREJ WOODS",
        "OASIS/ICON",
        "SONIPAT",
    ],
    "South-site": [
        "RGA TECH PARK",
        "GODREJ AVENUES",
        "BENGAL LAMPS",
        "GODREJ ROYALE WOODS",
        "GODREJ ETERNITY",
        "AGROVET",
        "BALGUR",
        "GODREJ NURTURE",
        "WHITEFIELD GARDEN CITY",
        "ORAGADAM",
        "KOKAPET",
        "VIBHUTHIPURA",
        "BANNERGHATA",
        "YESHWANTHPUR",
        "BEL HYDERABAD",
        "BANGALORE RO",
        "RGA 2",
        "GODREJ PARK RETREAT",
        "WOODSCAPE",
        "WOODLAND",
        "ANANDA",
        "ATHENA",
        "GODREJ ORAGADAM",
        "SPLENDOUR"
    ],
    "Mumbai/MMR-site": [
        "BHANDUP",
        "CARMICHAEL",
        "GODREJ ASCEND",
        "GODREJ AVENUE 11",
        "GODREJ BAYVIEW",
        "GODREJ CITY",
        "GODREJ EMERALD",
        "GODREJ EXQUISITE",
        "GODREJ FIVE GARDENS",
        "GODREJ HORIZON",
        "GODREJ NIRVAAN",
        "GODREJ PRIME",
        "GODREJ RESERVE",
        "GODREJ RIVIERA",
        "GODREJ RKS",
        "GODREJ SKY TERRACES",
        "GODREJ TRANQUIL",
        "GODREJ UPAVAN",
        "GODREJ URBAN PARK",
        "GODREJ VIHAA",
        "IMAGICA",
        "KHALAPUR",
        "MANOR"
    ],
    "West-East-site": [
        "GODREJ SECTOR 146",
        "GODREJ MERIDIEN",
        "GODREJ AIR",
        "GODREJ SUMMIT",
        "GODREJ NATURE PLUS",
        "GODREJ SECTOR 43 GGN",
        "SONIPAT",
        "GODREJ NEST & NURTURE",
        "GODREJ SOUTH ESTATE",
        "GODREJ KURUKSHETRA",
        "GODREJ SECTOR 49",
        "GODREJ SECTOR 103",
        "GODREJ HABITAT",
        "GODREJ SECTOR 89",
        "GODREJ TDI",
        "GODREJ GOLF LINK",
        "GODREJ PALM RETREAT",
        "GODREJ WOODS",
        "GODREJ ARIA/101",
        "ASHOK VIHAR",
        "GODREJ SECTOR 54",
        "FARIDABAD",
        "OASIS/ICON",
        "NAGPUR",
        "MAMURDI",
        "MAHALUNGE",
        "MANJARI",
        "GGC",
        "KP NX",
        "SE7EN",
        "ICC",
        "MAAN-HINJE",
        "PRAKRITI",
        "PUNE RO",
        "NAGPUR 2",
        "MUNDHWA",
        "BL SAHA",
        "MAAN HINJE",
        "ICC - PIMPRI",
        "MUNDHAWA",
        "ZO",
        "KP2",
        "KESHAVNAGAR",
    ],
    gender: genderOptions,
    verticalType: verticalTypeOptions,
    productWorked: productWorkedOptions,
    ticketSize: ticketSizeOptions,
    avgIncentive: incentiveOptions,
    workedInBank: workedInBankOptions,
    candidateType: candidateTypeOptions,
    industry: industryOptions,
    workExperience: workExperienceOptions,
    state: stateOptions,
}

/**
 * In-field placeholder hints shown inside each input.
 * Intentionally different from the field's label/question text (which now sits on top),
 * giving the candidate a format/example cue instead of repeating the question.
 * Hardcoded by design — keyed by the input's keyName.
 */
export const placeholderHints = {
    // Personal Details
    dob: "DD/MM/YYYY",
    alternateContact: "Enter alternate number",
    currentResidential: "House no., street, area, landmark",
    permanentResidential: "House no., street, area, landmark",
    city: "e.g. Bengaluru",
    pin: "e.g. 560001",
    language: "e.g. English, Hindi, Tamil",
    motherTongue: "e.g. Kannada",
    familyMembers: "e.g. 4",
    dependentFamilyMembers: "e.g. 2",
    // University Details
    universityRegistrationNumber: "e.g. 1AB21CS001",
    universitySeatNumber: "Enter your seat number",
    // Educational Qualification
    highestQualification: "e.g. B.Tech, MBA",
    stream: "e.g. Computer Science",
    collegeName: "Enter your college name",
    percentage: "e.g. 75% or 8.2 CGPA",
    yearOfPassing: "e.g. 2022",
    educationSpecialization: "e.g. Data Science",
    twelfthPercentage: "e.g. 78%",
    twelfthYearOfPassing: "e.g. 2018",
    tenthPercentage: "e.g. 82%",
    tenthYearOfPassing: "e.g. 2016",
    // Job Details
    industry: "Select an industry",
    currentCompany: "Enter company name",
    workExperience: "Select experience range",
    currentLocation: "Enter city name",
    state: "Select a state",
    yearsOfExp: "e.g. 3",
    compensation: "e.g. 12",
    company: "Enter company name",
    noticePeriod: "e.g. 30",
    locationPreference: "Select preferred locations",
    edpId: "Enter EDP ID or N/A",
    zoneName: "Select a zone",
    site: "Select a site",
    productWorked: "Select products",
    ticketSize: "Select ticket size",
    avgIncentive: "Select incentive range",
    sourceOfHiring: "e.g. LinkedIn, Referral",
    referral: "Enter name / consultancy",
    branchDistance: "e.g. 5 km",
}

export const dropdownInputMode = {
    zoneName: "single",
    site: "single",
    locationPreference: "multiple",
    gender: "single",
    verticalType: "single",
    productWorked: "multiple",
    ticketSize: "single",
    avgIncentive: "single",
    workedInBank: "single",
    candidateType: "single",
    industry: "single",
    workExperience: "single",
    state: "single",
}
